<template>
    <div class="panel no-title active-bonus">
      <div class="title" v-if="!isMobile">Aktif Bonus</div>
      <div class="content" v-if="_.isEmpty(openBonus)">
        <div class="alert">
          Sonuç Bulunamadı
        </div>
      </div>
      <slot v-if="!_.isEmpty(openBonus)">
        <div class="content" v-for="(item,key) in openBonus" :key="key">
          <div class="top" :class="{ 'direction-column' : isMobile }">
            <div class="info">
              <div class="label">
                <strong>{{ item.bonus_id_name }}</strong>
                <strong>{{ item.amount }}</strong>
              </div>
              <div class="label">
                <p>{{ $t(item.bonus.type_name) }} </p>
                <small>{{ $moment(item.updated_at).format('MM/DD HH:MM:SS') }}</small>
              </div>
              <div class="label">
                <b>Kalan Gün: {{ item.expire_at }} </b>
                <span class="status-label" :class="'status_' + item.status">{{ item.status_name }}</span>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="row justify-center" :class="{ 'direction-column' : isMobile }">
              <div class="col direction-column justify-center">
                <div class="label">
                  <span>Minimum Oran: <strong> {{ item.bonus.min_rate }}</strong></span>
                </div>
                <div class="label">
                  <span>Kombine Kupon: <strong>{{ (_.isNull(item.bonus.total_rate) && _.isNull(item.bonus.single_rate) ? 'Var' : (item.bonus.total_rate + ' toplam veya üstü')) }}</strong></span>
                </div>

              </div>
              <div class="col direction-column justify-center">
                <div class="box">
                  <div class="label">
                    <span>Çevrim şartına uygun olmayan kupon <strong>{{ ((!_.isUndefined(item.bonus.limits) && !_.isUndefined(item.bonus.limits.non_compliant_coupon) && item.bonus.limits.non_compliant_coupon == 1) ? 'Oynanabilir' :  'Oynanabilir') }}</strong> </span>
                  </div>
                  <div class="label">
                    <span>İki Yollu <strong>{{ ((!_.isUndefined(item.bonus.two_ways) && item.bonus.two_ways == 1) ? 'Oynanabilir' :  'Oynanamaz') }}</strong> </span>
                  </div>
                  <div class="label">
                    <span>Aldığı Bonusun Kaç Katını Kazanabilir : <strong>{{ ((!_.isUndefined(item.bonus.max_win)) ? item.bonus.max_win.replace('.00','') : '0') }}</strong></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slot>
    </div>
</template>
<script>
  export default{
    props:['openBonus']
  }
</script>
